






























import {Component, Mixins} from 'vue-mixin-decorator';
import {Inject} from 'inversify-props';
import {getModule} from 'vuex-module-decorators';

import {Notify} from '@/utils/Notify';

import {AntennaType} from '@/model/lora/AntennaType';

import {ISettingsService} from '@/services/settings/ISettings.service';
import {Setting} from '@/services/settings/Settings.types';
import {ILoraHardwareService} from '@/services/lora/ILoraHardware.service';

import LoraHardwareStore from '@/store/lora/LoraHardware.store';

import {BaseComponent} from '@/mixins/BaseComponent';
import {Time} from '@/utils/Time';
import {ISystemInfoService} from '@/services/system/IInfo.service';
import SystemInfoStore from '@/store/system/SystemInfo.store';
import {SoftwareDetails} from '@/model/system/SoftwareDetails';

@Component({
  components: {},
})
export default class GuiVersionBanner extends Mixins<BaseComponent>(BaseComponent) {

  @Inject(Symbol.for('ISystemInfoService'))
  private systemInfoService!: ISystemInfoService;

  private systemInfoStore: SystemInfoStore = getModule(SystemInfoStore, this.$store);

  private loadedVersion = process.env.VERSION;

  private async mounted() {
    await Time.sleep(5000);

    await this.refresh();
  }

  private async refresh() {
    this.setLoading();
    try {
      await this.systemInfoStore.fetchSoftwareDetails();
    } catch (error) {
      Notify.Error(this.logger, `Could not fetch system software versions`, error);
    } finally {
      this.setLoaded();
    }
  }

  get managerUiVersion(): string | undefined {
    return this.systemInfoStore.SoftwareDetails?.find((s: SoftwareDetails) => s.Id === 'manager-ui')?.Version;
  }

  private reload() {
    location.reload(true);
  }
}
